const scrollToTop = () => {
    let topVar = 240;

    if(window.innerWidth <= 875)
        topVar = 700;
    if(window.innerWidth <= 768)
        topVar = 470;
    if(window.innerWidth <= 630)
        topVar = 1105;

    window.scrollTo({
        top: topVar,
        behavior: 'smooth'
    });
}

export default scrollToTop;